var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlcoholicDrinksStandard = function SvgAlcoholicDrinksStandard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 17.204 21.2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M8.602 10.6v10m0-10-7.55-7.43C.095 2.227.762.6 2.104.6H15.1c1.342 0 2.008 1.628 1.052 2.569zm0 10h-3m3 0h3m-9.096-16h12.192"
  })));
};
export default SvgAlcoholicDrinksStandard;